import type express from 'express';

export type Response = {} & express.Response;
